/**
 * Collapsible Info Block (Aqua)
 * Smooth accordion functionality with open/close animations
 */

(function() {
  'use strict';

  function initCollapsible() {
    const triggers = document.querySelectorAll('[data-collapsible-trigger]');

    triggers.forEach(trigger => {
      const content = trigger.nextElementSibling;
      if (!content || !content.hasAttribute('data-collapsible-content')) return;

      // Handle click
      trigger.addEventListener('click', () => {
        const isOpen = trigger.classList.contains('collapsible-info__button--open');

        if (isOpen) {
          closeCollapsible(trigger, content);
        } else {
          openCollapsible(trigger, content);
        }
      });

      // Set initial height for items that are open by default
      if (trigger.classList.contains('collapsible-info__button--open')) {
        requestAnimationFrame(() => {
          const textContent = content.querySelector('.collapsible-info__text');
          if (textContent) {
            content.style.maxHeight = (textContent.scrollHeight + 40) + 'px';
          }
        });
      }
    });
  }

  function openCollapsible(trigger, content) {
    trigger.classList.add('collapsible-info__button--open');
    trigger.setAttribute('aria-expanded', 'true');
    content.classList.add('collapsible-info__content--open');

    // Set max-height to actual content height for smooth transition
    const textContent = content.querySelector('.collapsible-info__text');
    if (textContent) {
      content.style.maxHeight = (textContent.scrollHeight + 40) + 'px';
    }
  }

  function closeCollapsible(trigger, content) {
    trigger.classList.remove('collapsible-info__button--open');
    trigger.setAttribute('aria-expanded', 'false');
    content.classList.remove('collapsible-info__content--open');

    // Reset max-height for smooth collapse
    content.style.maxHeight = '0';
  }

  // Initialize on load
  function init() {
    initCollapsible();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-collapsible-info')) {
      setTimeout(init, 100);
    }
  });
})();
